export default __webpack_public_path__ + "static/media/TaskAppResponsiveSmall.d7c1413a.png";